require('../../modules/es.typed-array.slice');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/typed-array/slice.js
// module id = 1234
// module chunks = 1